"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMMIGRATION_TPS = exports.IMMIGRATION_DACA = exports.IMMIGRATION_WORK_PERMIT = exports.IMMIGRATION = exports.JUSTICE_ADVOCATE_DEBT_LAWSUIT = exports.ILLEGAL_DEBT_COLLECTION = exports.CREDIT_COUNSELING = exports.BANKRUPTCY = void 0; // Bankruptcy/Finance

exports.BANKRUPTCY = "bankruptcy";
exports.CREDIT_COUNSELING = "creditCounseling";
exports.ILLEGAL_DEBT_COLLECTION = "illegalDebtCollection";
exports.JUSTICE_ADVOCATE_DEBT_LAWSUIT = "justiceAdvocateDebtLawsuit"; // Immigration

exports.IMMIGRATION = "immigration";
exports.IMMIGRATION_WORK_PERMIT = "immigrationWorkPermit";
exports.IMMIGRATION_DACA = "immigrationDACA";
exports.IMMIGRATION_TPS = "immigrationTPS";